﻿(function ($) {
    openAudienceModalDialog = function (redirecturl, modalUrl, modalClass) {
        createPopupDialog();

        var $targetModal = $('#popupDialog');
        var spinner = doSpinnerByLoadingId(null, null, 'modal-spinner');
        $targetModal.modal({ backdrop: 'static', keyboard: false, show: true });
        var targetIframe = $targetModal.find('iframe');
        if (targetIframe) {
            $targetModal.find('iframe').remove().attr('src', '');
        }
        var iframe = $('<iframe id=\"selector\" frameborder=\"0\">');
        var iframeUrl = '/audience-selector-modal/';
        if (modalUrl) {
            iframeUrl = modalUrl;
        }
        if (redirecturl !== undefined && redirecturl !== '') {
            if (iframeUrl.match(/\?./)) {
                iframeUrl = iframeUrl + "&returnurl=" + redirecturl;
            } else {
                iframeUrl = iframeUrl + "?returnurl=" + redirecturl;
            }
            $targetModal.addClass('ahp-deeplink-modal');
        }
        else {
            $targetModal.addClass('ahp-selector-modal');
        }
        iframe.attr('src', iframeUrl);
        iframe.load(function () {
            stopSpinnerByLoadingId(spinner, null, 'modal-spinner');
            $(this).show();
        });
        $('.modal-body', $targetModal).append(iframe);
        $targetModal.modal();
        $targetModal.find('.modal-header').remove();
        $targetModal.find('.modal-footer').remove();
        window.closeModal = function () { $targetModal.modal('hide'); };
    };

    openSimpleIframeModalDialog = function (modalUrl, modalClass) {
        createPopupDialog();

        var $targetModal = $('#popupDialog');

        var additionalClasses = 'modal-simple-iframe ' + modalClass;
        $targetModal.addClass(additionalClasses);

        var spinner = doSpinnerByLoadingId(null, null, 'modal-spinner');
        $targetModal.modal({ backdrop: 'static', keyboard: false, show: true });
        var targetIframe = $targetModal.find('iframe');
        if (targetIframe) {
            $targetModal.find('iframe').remove().attr('src', '');
        }
        var iframe = $('<iframe id=\"selector\" frameborder=\"0\">');

        iframe.attr('src', modalUrl);
        iframe.load(function () {
            stopSpinnerByLoadingId(spinner, null, 'modal-spinner');
            $(this).show();
        });
        $('.modal-body', $targetModal).append(iframe);
        $targetModal.modal();
        $targetModal.find('.modal-footer').remove();
        window.closeModal = function () { $targetModal.modal('hide'); };
        $targetModal.on('hidden.bs.modal', function () { $targetModal.removeClass(additionalClasses); });
    };

    createPopupDialog = function (popupClass) {
        if (popupClass === undefined) {
            popupClass = "";
        }

        var template = "<div id='popupDialog' class='modal fade" + popupClass + "' tabindex='-1' role='dialog'>" +
            "  <div class='modal-dialog' role='document'>" +
            "    <div class='modal-content'>" +
            "      <div class='modal-header'>" +
            "        <button type='button' class='close' data-dismiss='modal' aria-label='Close'><span aria-hidden='true'>&times;</span></button>" +
            "      </div>" +
            "      <div class='modal-body'>" +
            "        <div id='modal-spinner'>" +
            "        </div>" +
            "      </div>" +
            "      <div class='modal-footer disclaimerpop'></div>" +
            "    </div>" +
            "  </div>" +
            "</div>";

        if ($("#popupDialog").length === 0) {
            $("body").append(template);
        }

        $(".modal").on('hidden.bs.modal', function (e) {
            $(e.target).data('modal', null);
            $('.modal').remove();
            $('.modal-backdrop').remove();
            $('body').removeClass("modal-open");
        });
    };

    $(document).ready(function () {
        var $element = $('.au-share-popover');
        if ($element[0]) {
            $element.popover({
                html: true,
                placement: 'bottom',
                title: '<span class="text-info"><strong>Share</strong></span>' +
                    '<button type="button" id="close" class="close">&times;</button>',
                container: $('body'),
                content: $('#content').html()
            }).click(function (e) {
                e.preventDefault();
                $('.popover').css('left', $(this).offset().left - 170 + 'px');
                $('.popover').css('top', $(this).offset().top + 30 + 'px');
                $('.popover .arrow').css('display', 'none');
            });;

            $element.on('shown.bs.popover', function () {
                var popover = $element.data('bs.popover');
                if (typeof popover !== "undefined") {
                    var $tip = popover.tip();
                    zindex = $tip.css('z-index');
                    $tip.find('.close').bind('click', function () {
                        $element.click();
                    });
                }
            });
        }
    });

    $(document).ready(function () {
        initMainTabs();
        initMainNavigation();
        initWidgetTabs();
        initNewRow();
        //initFundPricesWidget();  //Don't need to do any more since SRI's code has the correct URL and causing duplicate windows
        initColumnWithHighchartWidget();
        initLineHighchartWidget();
        initCountryWeightings();
        initCalenderReturnsChart();
        initPremiumDiscountChart();

        $("[data-toggle=modal][data-target='#popupDialog']").click(clickIframeModalLink);

        $('#open-ahp-modal-microsites,#open-ahp-modal-mobile').click(function (e) {
            openAudienceModalDialog('', '/profile/reselect/', '');
        });

        getHtml = function (dataUrl) {
            return $.ajax({
                type: "GET",
                url: dataUrl,
                cache: false,
            });
        }

    });
})(jQuery);

function initMainTabs() {
    //Calculate all tabs width.
    var totalWidth = $("nav.in_right ul").width();
    var calculatedWidth = 0;
    var tabsWidth = 0;
    var tabs = $("nav.in_right li");
    $.each(tabs, function (index, tab) {
        tabsWidth += $(tab).width();
    });
    var remainderWidth = totalWidth - tabsWidth;
    var addWidth = remainderWidth / tabs.length;

    //Resize tab width and align.
    $.each(tabs, function (index, tab) {
        var adjustedWidth = $(tab).width() + addWidth;
        calculatedWidth += adjustedWidth;

        //Border adds width so remove excess over total width on last item.
        if (index === tabs.length - 1) {
            if (calculatedWidth > totalWidth) {
                adjustedWidth = adjustedWidth - (calculatedWidth - totalWidth);
            }
        }

        $(tab).css("width", adjustedWidth + "px");
        $(tab).children("a")
              .css("width", adjustedWidth + "px")
              .css("text-align", "center");
    });
}

function initMainNavigation() {
    $('#drop_tab_green').mouseover(function () {
        if (!$('.drop').hasClass('selected')) {
            $('.drop').addClass('selected');
        }
    });

    $('#drop_tab_green').mouseleave(function () {
        if ($('.drop').hasClass('selected')) {
            $('.drop').removeClass('selected');
        }
    });

    $('.drop').mouseover(function () {
        if (!$('.drop').hasClass('selected')) {
            $('.drop').addClass('selected');
        }
    });

    $('.drop').mouseleave(function () {
        if ($('.drop').hasClass('selected')) {
            $('.drop').removeClass('selected');
        }
    });
}

function initWidgetTabs() {
    $(".wi_tabs .tabNavigation a").click(function() {
        var parent = $(this).closest(".wi_tabs");
        parent.find(".tabNavigation a").removeClass("selected");
        parent.find(".wi_tabs_table").hide();

        $(this).addClass("selected");
        var pos = $(this).attr("pos");
        parent.find(".wi_tabs_table.pos" + pos).show();

        return false;
    });

    $(".tabNavigation a[pos=1]").click();
}

function initNewRow() {
    $(".wiNewRow").closest(".PBItem").addClass("clear");
    if ($.browser && $.browser.msie && $.browser.version <= 7)
    {
        var mas = $(".wiNewRow").closest(".PBItem");
        $.each(mas, function(index, value) {
            var prev1 = $(value).prev();
            var prev2 = prev1.prev();
            if (prev1.length === 1 && prev2.length === 1) {
                var prev2H;
                var prev2MasDiv = prev2.find("div");
                $.each(prev2MasDiv, function(i, val) {
                    if ($(val).height() > 0) {
                        prev2H = $(val).height();
                        return false;
                    }
                });

                var prev1MasDiv = prev1.find("div");
                $.each(prev1MasDiv, function(i, val) {
                    var curH = $(val).height();
                    if (curH > 0) {
                        if (curH < prev2H) { $(val).height(prev2H); }
                        return false;
                    }
                });

                prev1.addClass("AddedHeight_ie7");
            }
        });
     }   
}

function initFundPricesWidget() {
    /* limit this to only prices dropdown */
    $(".prices .jqTransformSelectWrapper ul li a").click(function () {
        var index = $(this).attr("index");
        var options = $(this).closest(".jqTransformSelectWrapper").find("select.jqTransformHidden option");
        var url = $(options[index]).attr("value");
        if (url !== "0") {
            open(url, "displayWindow", "width=700,height=500,left=200,top=150,status=no,toolbar=no,menubar=no");
        }
    });
}

window.initPremiumDiscountChart = function() {
    $(".premium_discount_chart").each(function (i, val) {
        var uniqueName = "chart" + i;
        $(val).attr("id", uniqueName);

        var sCategories = eval($('.hidden_data_feilds').find('.hdnCategoriesClass').val());

         var chart = new Highcharts.Chart({
            chart: {
                renderTo: uniqueName,
                type: 'bar',
                width: 600,
                height: 350
            },
            colors: ['#0033A0'],
            title: {
                text: $('.hidden_data_feilds').find('.hdnChartTitleClass').val()
            },
            xAxis: {
                categories: sCategories,
                lineColor: '#0033A0',
                labels: {
                    enabled: true,
                    style: {
                        fontSize: '11px'
                    },
                    gridLineWidth: 0
                },
                title: {
                    text: $('.hidden_data_feilds').find('.hdnXaxisTitleClass').val()
                }
            },
            yAxis: {
                min: 0,
                title: {
                    text: $('.hidden_data_feilds').find('.hdnYaxisTitleClass').val()
                },
                lineColor: '#0033A0',
                lineWidth: 1,
                labels: {
                    overflow: 'justify'
                }
            },
            tooltip: {
                formatter: function () {
                    return '' +
                        this.series.name + ': ' + this.y + $('.hidden_data_feilds').find('.hdnDaysTitleClass').val();
                }
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: false
                    }
                }
            },
            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'top',
                x: -100,
                y: 100,
                floating: true,
                borderWidth: 1,
                backgroundColor: '#FFFFFF',
                shadow: true
            },
            credits: {
                enabled: false
            },
            series: [{
                name: $('.hidden_data_feilds').find('.hdnNameClass').val(),
                data: eval($('.hidden_data_feilds').find('.hdnSeriesDataClass').val())
            }]
        });
    });
}

function htmlUnescape(value) {
    return String(value)
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&amp;/g, '&');
}

window.initCalenderReturnsChart = function() {
    $(".charttablenav").each(function (i, val) {
        var uniqueName = "chart" + i;
        $(val).attr("id", uniqueName);

        var sCategories = eval($('.chart-hidden-fields').find('.hdnCalendarReturnsChartCategories').val());
        var masData = eval($('.chart-hidden-fields').find('.hdnCalendarReturnsChartData').val());
        var nodata = $('.chart-hidden-fields').find('.hdnCalendarReturnsChartNoData').val();

        if (nodata !== '') {
            $('#' + uniqueName).html(htmlUnescape(nodata));
        }
        else {
            var chart = new Highcharts.Chart({
                chart: {
                    renderTo: uniqueName,
                    type: 'column',
                    marginLeft: 28,
                    marginBottom: 130
                },
                title: {
                    text: ''
                },
                xAxis: {
                    categories: sCategories,
                    lineColor: '#000000',
                    lineWidth: 1
                },
                yAxis: {
                    title: {
                        text: ''
                    },
                    lineColor: '#000000',
                    lineWidth: 1
                },
                legend: {
                    useHTML: true,
                    layout: 'vertical',
					align: 'left',
					verticalAlign: 'bottom',
                    borderWidth: 0
                },
                tooltip: {
                    formatter: function () {
                        return '' +
                        this.series.name + ': ' + this.y + '';
                    }
                },
                credits: {
                    enabled: false
                },
                series: masData
            });
            chart.legend.group.div.setAttribute('data-ve-gtm', 'chart-legend');
        }
    });
}

window.initCountryWeightings = function(){
    $(".country_chart_container_pie").each(function (i, val) {
        var uniqueName = "chart" + i;
        $(val).attr("id", uniqueName);

        var masColor = [];
        var masData = [];
        $(val).parent().find(".bottomRule tr td.leftAlign").each(function (i2, val2) {
            var col1 = $(val2).find(".label").text();
            var col2 = $(val2).find(".value").text();
            var flo = parseFloat(col2);
            if (flo >= 0.0) {
                masData.push([col1, flo]);
            }
            masColor.push($(val2).find(".color").text());
        });
        if (masData.length === 0) return;

        Highcharts.setOptions({ colors: masColor });
        var chart = new Highcharts.Chart({
            chart: {
                renderTo: uniqueName,
                plotBackgroundColor: null,
                plotBorderWidth: null,
                backgroundColor: '#FFFFFF',
                plotShadow: false,
                height: 230,
                width: 230,
                margin: [0, 0, 0, 0]
            },
            credits: {
                enabled: false
            },
            title: {
                text: ''
            },
            tooltip: {
                formatter: function () {
                    return '<b>' + this.point.name + '</b>' + this.y + ' %';
                },
                style: {
                    fontSize: '9px'
                }
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    center: [100, 100],
                    dataLabels: {
                        enabled: false,
                        formatter: function () {
                            return '<b>' + this.point.name + '</b>' + this.x + ' %';
                        }
                    }
                }
            },
            series: [{ type: 'pie', data: masData}]
        });
    });
}

window.initColumnWithHighchartWidget = function() {
    /*this is intented for PIE charts driven by specific SMARTFORMS to automatically populate a highcharts*/
    $(".chart_container_pie").each(function (i, val) {
        var uniqueName = "chart" + i;
        $(val).attr("id", uniqueName);

        var masColor = [];
        $(val).parent().find(".details .dia_color").each(function (i2, val2) {
            masColor.push($(val2).css("background-color"));
        });
        if (masColor.length === 0) return;

        var masData = [];
        $(val).parent().find(".details .data").each(function (i2, val2) {
            var col1 = $(val2).find(".col1").text();
            var col2 = $(val2).find(".col2").text();
            var flo = parseFloat(col2);
            if (flo >= 0.0) {
                masData.push([col1, flo]);
            }
        });
        if (masData.length === 0) return;

        Highcharts.setOptions({ colors: masColor });
        var chart = new Highcharts.Chart({
            chart: {
                renderTo: uniqueName,
                plotBackgroundColor: null,
                plotBorderWidth: null,
                backgroundColor: '#FFFFFF',
                plotShadow: false,
                height: 255,
                align: 'center',
                margin: [15, 0, 0, 0]
            },
            credits: { enabled: false },
            title: { text: '' },
            tooltip: {
                formatter: function () {
                    var pointName = this.point.name;
                    if (pointName.length > 20) { pointName = pointName.substring(0, 20) + ".."; }
                    return '<b>' + pointName + '</b>:' + this.y + '%';
                }
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    center: [100, 100],
                    dataLabels: {
                        enabled: false,
                        formatter: function () {
                            var pointName = this.point.name;
                            if (pointName.length > 20) { pointName = pointName.substring(0, 20) + ".."; }
                            return '<b>' + pointName + '</b>:' + this.y + '%';
                        }
                    }
                }
            },
            series: [{ type: 'pie', data: masData}]
        });
    });
}

window.initLineHighchartWidget = function () {
    $(".line_chart_container_pie").each(function(i, val) {
        var uniqueName = "line_chart" + i;
        $(val).attr("id", uniqueName);

        var masDataX = [];
        var masData = [];
        $(val).parent().find(".line_chart_data input").each(function(i2, val2) {
            masDataX.push($(val2).attr("name"));
            var value = $(val2).attr("value");
            var flo = parseFloat(value);
            if (flo >= 0.0) {
                masData.push(flo);
            }
        });
        if (masDataX.length === 0 || masData.length === 0) return;

        chart = new Highcharts.Chart({
            chart: {
                renderTo: uniqueName,
                type: 'column'
            },
            title: { text: null },
            xAxis: {
                title: { text: 'Years' },
                categories: masDataX,
                labels: {
                    rotation: -40,
                    align: 'right',
                    style: {
                        fontSize: '12px',
                        fontFamily: 'Verdana, sans-serif'
                    }
                }
            },
            yAxis: {
                min: 0,
                tickPixelInterval: 25,
                title: { text: null },
                labels: {
                    formatter: function() { return this.value + "%"; }
                }
            },
            legend: { enabled: false },
            tooltip: {
                formatter: function() {
                    return '<b>' + this.series.name + '</b><br/>' +
                            this.x + ': ' + this.y + '%';
                }
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0
                }
            },
            series: [{ name: 'Years', data: masData}],
            credits:{ enabled: false }
        });
    });
}

function getVerticalBannerAd(sUrl) {
    // TODO: VK - Remove the function when we find where this is invoked from.
}

function getModalDialogFromLink(selector) {
    return $(selector.data('target'));
}

function setSpinner(event) {
    $('.modal-body', $(this)).html('<div id="modal-spinner"></div>');
}

function generateModalButton(href, text, cssClass) {
    var button = $('<a />');
    button
    .attr({
        class: cssClass,
        href: href
    })
    .html('<span>' + text + '</span>');

    return button;
}

function getParameterByName(name, url) {
    if (!url)
        url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return '';
    return encodeURI(decodeURIComponent(results[2].replace(/\+/g, " ")));
}

function getParameterByNameDefault(name, url, defaultValue) {
    var paramValue = getParameterByName(name, url);
    if (paramValue === null) {
        return defaultValue;
    }

    return paramValue;
}

function clickIframeModalLink(event) {
    event.preventDefault();
    event.stopPropagation();

    createPopupDialog();

    var handler = $(this);
    var targetModal = getModalDialogFromLink(handler);
    var remote = handler.attr('href');

    var spinner = doSpinnerByLoadingId(null, null, 'modal-spinner');

	var enforceMinSize = getParameterByNameDefault('enforceminsize', remote, "false") === "true";
    var width = getParameterByNameDefault('width', remote, 672);
    var height = getParameterByNameDefault('height', remote, 460);

    //Enforce min width and height
	if (enforceMinSize) {
        if (width < 672) { width = 672; }
        if (height < 460) { height = 460; }
	}

    var windowHeight = $(window).height();
    if ((parseInt(height, 10) + 100) > windowHeight) {
        height = windowHeight - 150;
    }

    var footer = $('.modal-footer', targetModal);
    footer.html('');

    var showButtons = getParameterByNameDefault('button', remote, null) === "yes";
    if (showButtons) {
        var acceptBtnLink = getParameterByNameDefault('url', remote, null);
        if (acceptBtnLink !== null) {
            var acceptBtn = generateModalButton(acceptBtnLink, 'I Agree', 'agree-btn');
            acceptBtn.on("click", function () { targetModal.modal("hide"); });
            acceptBtn.attr("target", "_blank");
            footer.append(acceptBtn);
        }

        var declineBtnLink = getParameterByNameDefault('declineurl', remote, ".");
        if (declineBtnLink !== null) {
            var declineBtn = generateModalButton(declineBtnLink, 'I Decline', 'decline-btn');
            declineBtn.attr("data-dismiss", "modal");
            footer.append(declineBtn);
        }

        footer.show();
    } else {
        //No buttons so hide the footer.
        footer.hide();

        //Due to scroll bar we get no rounded corners. So add 6px to get the rounded corners.
        $('.modal-body', targetModal).css('margin-bottom', '6px');
    }

    var iframe = $('<iframe width="100%" height="100%">');
    iframe.attr('src', remote);
    iframe.load(function () {
        stopSpinnerByLoadingId(spinner, null, 'modal-spinner');
        $(this).show();
    });

    $('.modal-dialog', targetModal).css("width", width + 'px');
    $('.modal-body', targetModal).css("height", height + 'px')
                                 .append(iframe);
    targetModal.modal();
    targetModal.on('hidden.bs.modal', setSpinner);
    window.closeModal = function () { targetModal.modal('hide'); };
}

window.premiumDiscountModal = function(url) {
    try {
        var spinner = doSpinnerByLoadingId(null, null, 'modal-spinner');
        createPopupDialog();

        var targetModal = $('#popupDialog');
        var targetIframe = targetModal.find('iframe');
        if (targetIframe) {
            targetModal.find('iframe').remove().attr('src', '');
        }

        if (url.indexOf('Select') < 0) {
            var iframe = $('<iframe class="discountframe" width="694" height="430">');
            iframe.attr('src', url);
            iframe.load(function () {
                stopSpinnerByLoadingId(spinner, null, 'modal-spinner');
                $(this).show();
            });
            $('.modal-body', targetModal).css('margin-bottom', '6px')
                                                 .append(iframe);
            $('.modal-footer', targetModal).hide();
            $('#popupDialog').modal();
            $('#popupDialog').on('hidden.bs.modal', setSpinner);
			$('.ddlPremiumDiscount').prop('selectedIndex',0);
        }
    }
    catch (err) {
        alert(err);
    }
}
